import React from 'react'
import './Button.scss'

type ButtonProps = {
  children?: React.ReactNode
  color?: string
  disabled?: boolean
  solid?: boolean
  text?: string
}

class Button extends React.PureComponent<ButtonProps> {
  render() {
    const { children, color, disabled, solid, text, ...rest } = this.props
    let cname = 'Button-root'
    if (solid) cname += ' solid'
    if (color) cname += ` ${color}`
    if (disabled) cname += ' disabled'
    return (
      <button className={cname} {...rest}>
        <div className="Button-main">{!text ? children : text}</div>
      </button>
    )
  }
}

export default Button
